import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BandForm } from "Bands/components";
import { clearActionMeta, editBand } from "Bands/state";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, IBand } from "Bands/types";
import { useBandContext } from "Bands/contexts";

import { copy } from "shared/assets";
import { Band } from "shared/assets/icons";
import { Modal } from "shared/components";
import { IAPIState, IFormButtons, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";

const { editBand: editBandCopy } = copy;

interface EditBandModalProps {
  handleClose: () => void;
}

export const EditBandModal: FC<EditBandModalProps> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { bandId, band } = useBandContext();
  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.editBand));

  const handleSubmit = (band: Partial<IBand>) => {
    if (!bandId) return;

    dispatch(editBand({ bandId, bandData: band }));
  };

  const buttons: IFormButtons = {
    primary: true,
    secondary: {
      onClick: handleClose,
    },
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(BAND_ACTIONS.editBand));

      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: editBandCopy.success,
        })
      );
    }
  }, [apiMeta, handleClose, dispatch]);

  return (
    <Modal title={editBandCopy.title} icon={Band}>
      <BandForm
        defaultValues={{ title: band?.title }}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        hasError={!!apiMeta?.error}
        buttons={buttons}
        apiError={apiMeta?.error}
      />
    </Modal>
  );
};
